import React from "react";
import { LogOutIcon, CalendarCheck } from "lucide-react";

const MobileHeader = ({
  onSearch,
  searchQuery,
  onLogout,
  bookingsCount,
  onBookingClick,
}) => {
  return (
    <div className="mobile-header-gradient text-white p-3 sticky-top shadow d-flex justify-content-between align-items-center">
      <div className="ml-4 d-flex align-items-center bg-white rounded-pill px-3 flex-grow-1">
        <i className="mdi mdi-magnify text-muted mr-2"></i>
        <input
          type="text"
          className="form-control border-0 shadow-none px-0"
          placeholder="Search Item..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      <div className="d-flex align-items-center ml-2">
        <button
          className="btn text-white position-relative px-2"
          onClick={onBookingClick}
        >
          <CalendarCheck size={24} />
          {bookingsCount > 0 && (
            <span
              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
              style={{ transform: "translate(-50%, 20%)", fontSize: "0.65rem" }}
            >
              {bookingsCount}
            </span>
          )}
        </button>
        <button className="btn text-white px-2" onClick={onLogout}>
          <LogOutIcon size={24} />
        </button>
      </div>
    </div>
  );
};

export default MobileHeader;
